import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { LinkButton, ModalWindow, UIText2 } from '@cian/ui-kit';
import { reloadPage } from '@cian/valuation-utils-component';
import * as React from 'react';

import { TOfferFromHistoryData } from '../../../../../types/offerHistory';
import { Price, Error, Loading, DeactivatedLabel, KeyValTable } from '../../commonComponents';
import { OfferGallery } from '../OfferGallery';
import * as styles from './styles.css';

interface IOfferFromHistoryProps {
  isOpen: boolean;
  onClose(): void;
  title?: string;
  offer?: TOfferFromHistoryData | null;
  deactivatedTitle: string | null;
  isLoading?: boolean;
  isError?: boolean;
  onOfferShow(): void;
  onGalleryScroll(): void;
  onGalleryClick(): void;
  onRedirectToOfferClick(): void;
}

export const OfferFromHistory: React.FC<IOfferFromHistoryProps> = props => {
  const {
    isOpen,
    offer,
    onClose,
    title,
    isLoading,
    isError,
    deactivatedTitle,
    onOfferShow,
    onGalleryScroll,
    onGalleryClick,
    onRedirectToOfferClick,
  } = props;

  return (
    <ModalWindow
      open={isOpen}
      onClose={onClose}
      title={title}
      content={
        <>
          {offer && (
            <ActionAfterViewObserver callback={onOfferShow} triggerOnce={false}>
              <>
                {offer.images && (
                  <div className={styles['gallery']}>
                    <OfferGallery images={offer.images} onScroll={onGalleryScroll} onClick={onGalleryClick} />
                  </div>
                )}
                <div className={styles['price']}>
                  <Price diff={offer.prices.priceDiff} subprice={offer.prices.priceSqm}>
                    {offer.prices.price}
                  </Price>
                  {deactivatedTitle && <DeactivatedLabel title={deactivatedTitle} />}
                </div>
                <div className={styles['address']}>
                  <UIText2 color="text-secondary-default">{offer.address}</UIText2>
                </div>

                {!!offer.dealConditions && (
                  <KeyValTable title="Условия сделки" className={styles['features']} table={offer.dealConditions} />
                )}

                <KeyValTable
                  className={styles['features']}
                  table={offer.features}
                  title={offer.dealConditions ? 'Общая информация' : undefined}
                />
              </>
            </ActionAfterViewObserver>
          )}
          {isLoading && <Loading />}
          {isError && <Error handleClick={reloadPage} />}
        </>
      }
      footer={
        offer?.link && (
          <LinkButton
            href={offer.link}
            theme="fill_secondary"
            target="_blank"
            rel="noreferrer"
            fullWidth
            onClick={onRedirectToOfferClick}
          >
            Посмотреть объявление
          </LinkButton>
        )
      }
    />
  );
};
